import I18n from "lib/i18n/i18n";

const expandLIformatter = (path, count) => {
    let formattedLiArr = [];
    for (let i=1; i<=count; i++){
        let expandText = I18n.getString(`howItWorks::${path+i}::expandText`)
        if (expandText.includes('{fees_table}')){
            const fees_table = I18n.getString('feesTable')
            expandText = expandText.replace('{fees_table}', fees_table)
        }
        formattedLiArr.push({
            bullet: I18n.getString(`howItWorks::${path+i}::bullet`),
            expandText: expandText
        })
    }
    return formattedLiArr;

}

export const HIWdata = {
    mainPage: {
        mainTitle: I18n.getString('howItWorks::mainPage::mainTitle'),
        subTitle: I18n.getString('howItWorks::mainPage::subTitle'),
        allSetTitle: I18n.getString('howItWorks::mainPage::allSetTitle'),
        allSetText: I18n.getString('howItWorks::mainPage::allSetText'),
        allSetBtn: I18n.getString('howItWorks::mainPage::allSetBtn'),
        faqTitle: I18n.getString('howItWorks::mainPage::faqTitle'),
        faqBtn: I18n.getString('howItWorks::mainPage::faqBtn'),
        needHelpTitle: I18n.getString('howItWorks::mainPage::needHelpTitle'),
        needHelpBtn: I18n.getString('howItWorks::mainPage::needHelpBtn')
    },
    stepPreviewData: [
        {
            stepNum: I18n.getString('howItWorks::stepPreview::step1::num'),
            stepDesc: I18n.getString('howItWorks::stepPreview::step1::desc'),
            stepImg: 'howItWorks/steps/truck.svg'
        },
        {
            stepNum: I18n.getString('howItWorks::stepPreview::step2::num'),
            stepDesc: I18n.getString('howItWorks::stepPreview::step2::desc'),
            stepImg: 'howItWorks/steps/chill.svg',
            reverseMobile: true
        },
        {
            stepNum: I18n.getString('howItWorks::stepPreview::step3::num'),
            stepDesc: I18n.getString('howItWorks::stepPreview::step3::desc'),
            stepImg: 'howItWorks/steps/money.svg'
        }
    ],
    sectionsData: [
        {
            stepNum: I18n.getString('howItWorks::sectionData::step1::stepNum'),
            title: I18n.getString('howItWorks::sectionData::step1::title'),
            subtitle: I18n.getString('howItWorks::sectionData::step1::subtitle'),
            stepListItems: expandLIformatter('sectionData::step1::stepListItems::stepLI', 2),
            config: {
                id: 'scrl-01',
                backgroundColor: '#F9F9F9',
                phantomBackground: 'howItWorks/backgrounds/truck_grey.svg',
                phantomOffset: 'translateY(20%)',
                opacity: '1'
            }
        },
        {
            stepNum: I18n.getString('howItWorks::sectionData::step2::stepNum'),
            title: I18n.getString('howItWorks::sectionData::step2::title'),
            subtitle: I18n.getString('howItWorks::sectionData::step2::subtitle'),
            stepListItems: expandLIformatter('sectionData::step2::stepListItems::stepLI', 7),
            config: {
                reverseOrientation: true,
                id: 'scrl-02',
                phantomBackground: 'howItWorks/backgrounds/chill_grey.svg',
                phantomOffset: 'translateY(20%)',
                opacity: '1'
            }
        },
        {
            stepNum: I18n.getString('howItWorks::sectionData::step3::stepNum'),
            title: I18n.getString('howItWorks::sectionData::step3::title'),
            subtitle: I18n.getString('howItWorks::sectionData::step3::subtitle'),
            stepListItems: expandLIformatter('sectionData::step3::stepListItems::stepLI', 3),
            config: {
                id: 'scrl-03',
                backgroundColor: '#F9F9F9',
                phantomBackground: 'howItWorks/backgrounds/money_grey.svg',
                phantomOffset: 'translateY(20%)',
                opacity: '1'
            }
        }
    ],
    faqData: expandLIformatter('faqSection::faqLI', 7),
    needHelpData: [
        {
            icon: "howItWorks/needHelp/phone.svg",
            title: I18n.getString('howItWorks::needHelpData::phone::title'),
            text: I18n.getString('howItWorks::needHelpData::phone::text'),
        },
        {
            icon: "howItWorks/needHelp/chat.svg",
            title: I18n.getString('howItWorks::needHelpData::chat::title'),
            text: I18n.getString('howItWorks::needHelpData::chat::text'),
        },
        {
            icon: "howItWorks/needHelp/envelope.svg",
            title: I18n.getString('howItWorks::needHelpData::envelope::title'),
            text: I18n.getString('howItWorks::needHelpData::envelope::text'),
        },
    ]
};
